import { DateTime } from 'luxon';
// Just helps format the graphql data

/*!
 * Group items from an array together by some criteria or value.
 * (c) 2019 Tom Bremmer (https://tbremer.com/) and Chris Ferdinandi (https://gomakethings.com), MIT License,
 * @param  {Array}           arr      The array to group items from
 * @param  {String|Function} criteria The criteria to group by
 * @return {Object}                   The grouped object
 */
var groupBy = function(arr, criteria) {
  return arr.reduce(function(obj, item) {
    // Check if the criteria is a function to run on the item or a property of it
    var key = typeof criteria === 'function' ? criteria(item) : item[criteria];

    // If the key doesn't exist yet, create it
    if (!obj.hasOwnProperty(key)) {
      obj[key] = [];
    }

    // Push the value to the object
    obj[key].push(item);

    // Return the object to the next item in the loop
    return obj;
  }, {});
};

export const defaultData = {
  guideName: '',
  guestName: '',
  stayStart: '',
  stayEnd: '',
  wake: '',
  meals: [],
  intentions: [],
  days: {},
  assessment: {
    start: null,
    location: null,
  },
};

export default function formatWallData(data) {
  if (Object.keys(data).length === 0) return defaultData;
  const d = data.bookingParty;

  const assessment = d.appointments.find(
    a => a.activity.name === 'Assessement'
  );
  return {
    guestName: `${d.member.user.firstName} ${d.member.user.lastName}`,
    guideName: `${d.guideForBooking.user.firstName} ${d.guideForBooking.user.lastName}`,
    // TODO: Is this formatting OK?
    stayStart: DateTime.fromISO(d.booking.startDate)
      .setLocale('en')
      .toFormat('LLL dd'),
    stayEnd: DateTime.fromISO(d.booking.endDate)
      .setLocale('en')
      .toFormat('LLL dd'),
    assessment: {
      start: assessment
        ? DateTime.fromISO(assessment.startDate).toFormat('h:mm a')
        : null,
      location: assessment ? assessment.location.name : null,
    },
    wake: d.prearrival.preferredWakeTime,
    meals: d.prearrival.mealTimes,
    intentions: d.prearrival.intentions,

    days: Object.entries(
      groupBy(d.appointments, appointment =>
        DateTime.fromISO(appointment.startDate).toFormat('EEE d')
      )
    ).map(([key, value]) => ({
      date: key,
      events: value,
    })),

    logInTimestamp: new Date(),
  };
}
